/*
 * File: SearchSectionEnrollments.ts
 * Author: Austin Robinson
 * Date Created: 7/22/2023
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { privateApi } from 'api';

export type SearchSectionEnrollmentsParams = {
  courseSectionId?: string;
  active?: boolean;
  firstName?: string;
  lastName?: string;
};

export type SearchSectionEnrollmentsResult = {
  tenant_id: string;
  id: string;
  title: string | null;
  first_name: string | null;
  middle_name: string | null;
  last_name: string | null;
  nickname: string | null;
  email: string | null;
  date_of_birth: string | null;
  sex: string | null;
  active: boolean;
  created_at: string | null;
  updated_at: string | null;
  created_by: string | null;
  updated_by: string | null;
  des_id: string | null;
  student: {
    tenant_id: string;
    user_id: string;
    permit_num: string | null;
    permit_issued: string | null;
    permit_expiration: string | null;
    permit_restrictions: string | null;
    permit_endorsements: string | null;
    permit_created_at: string | null;
    permit_updated_at: string | null;
    medical_conditions: string | null;
    high_school: string | null;
  };
}[];

async function searchSectionEnrollments(
  params: SearchSectionEnrollmentsParams | undefined,
): Promise<SearchSectionEnrollmentsResult> {
  try {
    if (params === undefined) {
      return [];
    }

    // make api call
    const result = await privateApi.post(
      `${import.meta.env.VITE_API_BASE_URL}/courses/searchSectionEnrollments`,
      params,
      {
        // headers: {
        // },
      },
    );

    // return the data object
    return result.data as SearchSectionEnrollmentsResult;
  } catch (e) {
    return [];
  }
}

const useSearchSectionEnrollments = createQuery<SearchSectionEnrollmentsResult, SearchSectionEnrollmentsParams, Error>({
  queryKey: ['search_section_enrollments'],
  fetcher: (variables) => searchSectionEnrollments(variables),
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  enabled: (data) => !data,
});

export { searchSectionEnrollments, useSearchSectionEnrollments };
